import React from "react";

function RequestListingComponent() {
  const Tabledata = [
    {
      requestedFranchise: "PMNA franchise",
      user: "suhail",
      amount: "refund 890",
      reason: "food is not cooked well. and we confirmed the case",
      orderId: "orderID/218",
    },
    {
      requestedFranchise: "PMNA franchise",
      user: "suhail",
      amount: "refund 890",
      reason: "food is not cooked well. and we confirmed the case",
      orderId: "orderID/218",
    },
    {
      requestedFranchise: "PMNA franchise",
      user: "suhail",
      amount: "refund 890",
      reason: "food is not cooked well. and we confirmed the case",
      orderId: "orderID/218",
    },
  ];
  return (
    <>
      {Tabledata.map((data, index) => {
        return (
          <tbody>
            <td>{data.requestedFranchise}</td>
            <td>{data.user}</td>
            <td>{data.amount}</td>
            <td>
            <a href={data.orderId}>
              {data.reason}</a></td>
              
            {/* <td>
              <a href={data.orderId}>
                <button className="btn btn-primary">Order Details</button>
              </a>
            </td> */}
          </tbody>
        );
      })}
    </>
  );
}

export default RequestListingComponent;
